export default __webpack_public_path__ + "static/media/Step3-cto.96f4ab34.svg";